<template>
  <div class="container">
    <wrap-container class="relative-container column-container">
      <step-header />
      <form-validator>
        <wrap-container>
          <section-label :value="config.pasos.paso3.copy" />
          <text-input
            label="Nombre"
            hint="Ingresa tu nombre"
            v-model="model.nombre"
            :required="true"
            @click="trackClick('nombre')"
          />
        </wrap-container>
        <wrap-container>
          <text-input
            label="Apellido"
            hint="Ingresa tu apellido"
            v-model="model.apellido"
            :required="true"
            @click="trackClick('apellido')"
          />
        </wrap-container>
        <wrap-container>
          <email-field
            label="Número de documento"
            hint="Ej: 28956372"
            v-model="model.email"
            :required="true"
            maxlength="8"
            @click="trackClick('email')"
          />
        </wrap-container>
        <wrap-container>
          <section-label class="cel-label" value="Teléfono de contacto" />
          <phone-number v-model="model.phone" :required="true" />
        </wrap-container>
        <wrap-container>
          <section-label
            value="Horario de preferencia para que te contactemos"
          />
          <contact-schedule
            class="margin-btn-24"
            v-model="model.horario"
            label="Selecciona una opción"
          />
        </wrap-container>
        <wrap-container>
          <position-or-sector
            class="margin-btn-24"
            v-model="model.cargoArea"
            label="Selecciona un cargo o área"
          />
        </wrap-container>
        <step-navigator :store-action="this.doNext" v-model="model" />
      </form-validator>
    </wrap-container>
  </div>
</template>

<script>
import WrapContainer from "@/components/core/Container";
import FormValidator from "@/components/core/FormValidator";
import SectionLabel from "@/components/core/SectionLabel";
import TextInput from "@/components/core/TextInput";
import EmailField from "@/components/core/EmailField";
import PhoneNumber from "@/components/core/composite/combos/PhoneNumber";
import ContactSchedule from "@/components/core/custom/ContactSchedule";
import PositionOrSector from "@/components/core/custom/PositionOrSector";
import StepNavigator from "@/components/core/StepNavigator";
import StepHeader from "@/components/core/StepHeader";
import { DO_PASO3 } from "../config/constants/action-types";
import * as ACTIONS from "@/config/constants/action-types";

export default {
  name: "Paso3",
  data() {
    return {
      model: this.$store.getters.getPaso3(),
      doNext: DO_PASO3
    };
  },
  components: {
    WrapContainer,
    FormValidator,
    SectionLabel,
    TextInput,
    EmailField,
    PhoneNumber,
    ContactSchedule,
    PositionOrSector,
    StepNavigator,
    StepHeader
  },
  methods: {
    trackClick(el) {
      /**
       * Hacer un dispatch del evento click sobre un elemento
       * para trackear analítica
       */
      this.$store.dispatch(ACTIONS.DO_CLICK_TRACKING, el);
    }
  }
};
</script>
<style scoped></style>
